/* LIVE FROM PINGPOPVERSE (T-K3).
   Fetches recent public community posts once after page load and renders them as cards.
   Every post field is written with textContent / setAttribute, never innerHTML. Links and
   images must be http(s) URLs. Any failure (network, timeout, bad JSON, no usable posts)
   hides the grid; the section's CTAs stay. */
(function () {
  'use strict';

  var TIMEOUT_MS = 5000;
  var MAX_POSTS = 6;
  var MAX_TITLE_CHARS = 120;
  var MAX_EXCERPT_CHARS = 200;
  var ENDPOINT_PATH = '/api/community/recent';

  function safeUrl(value, base) {
    if (typeof value !== 'string' || value.trim() === '') return null;
    try {
      var url = new URL(value.trim(), base);
      return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : null;
    } catch (e) {
      return null;
    }
  }

  function text(value, maxChars) {
    if (typeof value !== 'string') return '';
    var clean = value.replace(/\s+/g, ' ').trim();
    return clean.length > maxChars ? clean.slice(0, maxChars - 1) + '…' : clean;
  }

  function count(value) {
    return typeof value === 'number' && isFinite(value) && value > 0 ? Math.floor(value) : 0;
  }

  function el(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content) node.textContent = content;
    return node;
  }

  function fill(template, n, lang) {
    return template.replace('{n}', n.toLocaleString(lang));
  }

  function normalizePost(raw, origin) {
    if (!raw || typeof raw !== 'object') return null;
    var href = safeUrl(raw.url, origin);
    if (!href) return null;
    var author = raw.author && typeof raw.author === 'object' ? raw.author : {};
    var handle = text(author.handle, 60);
    var name = text(author.name, 60);
    var board = raw.board && typeof raw.board === 'object' ? text(raw.board.name, 60) : '';
    return {
      href: href,
      title: text(raw.title, MAX_TITLE_CHARS),
      excerpt: text(raw.excerpt, MAX_EXCERPT_CHARS),
      who: handle ? '@' + handle.replace(/^@/, '') : name,
      board: board,
      image: safeUrl(raw.image, origin),
      video: raw.video === true,
      spotlight: raw.spotlight === true,
      likes: count(raw.likes),
      comments: count(raw.comments)
    };
  }

  function buildMedia(post) {
    var media = el('div', 'kz-live__media');
    var showPlay = function () {
      media.className = 'kz-live__media kz-live__media--empty' + (post.video ? ' kz-live__media--video' : '');
      media.textContent = '';
      if (post.video) {
        var play = el('span', 'kz-live__play', '▶');
        play.setAttribute('aria-hidden', 'true');
        media.appendChild(play);
      } else {
        var mark = el('span', null, '✶');
        mark.setAttribute('aria-hidden', 'true');
        media.appendChild(mark);
      }
    };
    if (!post.image) {
      showPlay();
      return media;
    }
    var img = document.createElement('img');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
    img.setAttribute('alt', '');
    img.setAttribute('width', '640');
    img.setAttribute('height', '480');
    img.addEventListener('error', showPlay);
    img.setAttribute('src', post.image);
    media.appendChild(img);
    if (post.video) {
      var badge = el('span', 'kz-live__play', '▶');
      badge.setAttribute('aria-hidden', 'true');
      media.appendChild(badge);
    }
    return media;
  }

  function buildStat(symbol, value, template, lang) {
    var wrap = el('span');
    var visual = el('span', null, symbol + ' ' + value.toLocaleString(lang));
    visual.setAttribute('aria-hidden', 'true');
    wrap.appendChild(visual);
    wrap.appendChild(el('span', 'visually-hidden', fill(template, value, lang)));
    return wrap;
  }

  function buildCard(post, msg, lang, titleTag) {
    var card = el('li', 'kz-live__card');
    card.appendChild(buildMedia(post));

    var body = el('div', 'kz-live__body');
    if (post.who) body.appendChild(el('p', 'kz-live__meta kz-live__author', post.who));
    if (post.board) body.appendChild(el('p', 'kz-live__board', post.board));
    if (post.video && msg.video) body.appendChild(el('p', 'visually-hidden', msg.video));

    var label = post.title || post.excerpt || (post.who ? msg.postBy.replace('{who}', post.who) : msg.untitled);
    var heading = el(titleTag || 'h3', 'kz-live__post-title');
    var link = el('a', 'kz-live__post-link', label);
    link.setAttribute('href', post.href);
    link.setAttribute('rel', 'noopener');
    heading.appendChild(link);
    body.appendChild(heading);

    if (post.title && post.excerpt) body.appendChild(el('p', 'kz-live__excerpt', post.excerpt));

    var stats = el('p', 'kz-live__stats');
    stats.appendChild(buildStat('♥', post.likes, msg.likes, lang));
    stats.appendChild(buildStat('💬', post.comments, msg.comments, lang));
    body.appendChild(stats);

    card.appendChild(body);
    return card;
  }

  function fail(grid) {
    grid.hidden = true;
    grid.setAttribute('aria-busy', 'false');
  }

  function fillGrid(grid, posts, config, titleTag) {
    var cards = posts.map(function (post) { return buildCard(post, config.msg, config.lang, titleTag); });
    grid.textContent = '';
    cards.forEach(function (card) { grid.appendChild(card); });
    grid.setAttribute('aria-busy', 'false');
  }

  /* Grouped layout (T-S5): PINGPOP SPOTLIGHT first, then COMMUNITY, each its own labelled list. The
     original skeleton list becomes the community list. Without any Spotlight post there is one list and no
     group headings. */
  function render(grid, posts, config) {
    var spotlight = posts.filter(function (p) { return p.spotlight; }).slice(0, config.spotlight);
    var community = posts.filter(function (p) { return !p.spotlight; });
    if (config.spotlight === 0 || spotlight.length === 0) {
      fillGrid(grid, config.spotlight === 0 ? posts : community, config, 'h3');
      return;
    }
    var groups = el('div', 'kz-live__groups');
    var spotGroup = el('section', 'kz-live__group kz-live__group--spotlight');
    var spotTitle = el('h3', 'kz-live__group-title', config.msg.spotlight);
    var spotId = 'kz-live-spot-' + Math.random().toString(36).slice(2, 8);
    spotTitle.id = spotId;
    spotGroup.setAttribute('aria-labelledby', spotId);
    var spotGrid = el('ul', 'kz-live__grid');
    spotGroup.appendChild(spotTitle);
    spotGroup.appendChild(spotGrid);

    var commGroup = el('section', 'kz-live__group kz-live__group--community');
    var commTitle = el('h3', 'kz-live__group-title', config.msg.community);
    var commId = 'kz-live-comm-' + Math.random().toString(36).slice(2, 8);
    commTitle.id = commId;
    commGroup.setAttribute('aria-labelledby', commId);
    grid.parentNode.insertBefore(groups, grid);
    commGroup.appendChild(commTitle);
    commGroup.appendChild(grid);
    groups.appendChild(spotGroup);
    groups.appendChild(commGroup);

    fillGrid(spotGrid, spotlight, config, 'h4');
    fillGrid(grid, community, config, 'h4');
  }

  function readConfig(grid) {
    var origin = safeUrl(grid.getAttribute('data-api-origin'));
    var limit = parseInt(grid.getAttribute('data-limit'), 10);
    var spotlight = parseInt(grid.getAttribute('data-spotlight'), 10);
    var community = parseInt(grid.getAttribute('data-community'), 10);
    spotlight = isFinite(spotlight) && spotlight > 0 ? Math.min(spotlight, MAX_POSTS) : 0;
    if (spotlight > 0 && isFinite(community) && community > 0) limit = spotlight + community;
    var lang = grid.getAttribute('data-lang') === 'ko' ? 'ko' : 'en';
    if (!origin) return null;
    return {
      origin: new URL(origin).origin,
      limit: Math.min(isFinite(limit) && limit > 0 ? limit : MAX_POSTS, MAX_POSTS),
      lang: lang,
      spotlight: spotlight,
      msg: {
        spotlight: grid.getAttribute('data-msg-spotlight') || 'PINGPOP SPOTLIGHT ✦',
        community: grid.getAttribute('data-msg-community') || 'COMMUNITY',
        likes: grid.getAttribute('data-msg-likes') || '{n}',
        comments: grid.getAttribute('data-msg-comments') || '{n}',
        video: grid.getAttribute('data-msg-video') || '',
        untitled: grid.getAttribute('data-msg-untitled') || '',
        postBy: grid.getAttribute('data-msg-post-by') || '{who}'
      }
    };
  }

  function load(grid) {
    var config = readConfig(grid);
    if (!config || typeof fetch !== 'function' || typeof AbortController !== 'function') {
      fail(grid);
      return;
    }
    var endpoint = new URL(ENDPOINT_PATH, config.origin);
    endpoint.searchParams.set('limit', String(config.limit));
    endpoint.searchParams.set('lang', config.lang);
    if (config.spotlight > 0) endpoint.searchParams.set('spotlight', String(config.spotlight));

    var controller = new AbortController();
    var timer = setTimeout(function () { controller.abort(); }, TIMEOUT_MS);

    fetch(endpoint.href, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json' },
      signal: controller.signal
    })
      .then(function (response) {
        if (!response.ok) throw new Error('status ' + response.status);
        return response.json();
      })
      .then(function (data) {
        clearTimeout(timer);
        var list = data && Array.isArray(data.posts) ? data.posts : [];
        var posts = list
          .map(function (raw) { return normalizePost(raw, config.origin); })
          .filter(Boolean)
          .slice(0, config.limit);
        if (posts.length === 0) {
          fail(grid);
          return;
        }
        render(grid, posts, config);
      })
      .catch(function () {
        clearTimeout(timer);
        fail(grid);
      });
  }

  function start(scope) {
    var grids = (scope || document).querySelectorAll('[data-kz-live-grid]');
    Array.prototype.forEach.call(grids, function (grid) {
      if (grid.getAttribute('data-kz-live-started') === 'true') return;
      grid.setAttribute('data-kz-live-started', 'true');
      load(grid);
    });
  }

  function onReady() {
    start(document);
  }

  if (document.readyState === 'complete') {
    onReady();
  } else {
    window.addEventListener('load', onReady);
  }
  document.addEventListener('shopify:section:load', function (event) {
    start(event.target);
  });
})();
